export default __webpack_public_path__ + "static/media/winNotification.bac94d19.wav";